var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3699 24.29H23.6299C22.8529 24.29 22.1076 23.9813 21.5581 23.4318C21.0086 22.8823 20.7 22.1371 20.7 21.36V14.93C20.7 14.1529 21.0086 13.4077 21.5581 12.8582C22.1076 12.3087 22.8529 12 23.6299 12H40.3699C41.147 12 41.8923 12.3087 42.4418 12.8582C42.9913 13.4077 43.2999 14.1529 43.2999 14.93V21.36C43.2999 22.1371 42.9913 22.8823 42.4418 23.4318C41.8923 23.9813 41.147 24.29 40.3699 24.29ZM40.2999 14.93L23.6299 15L23.7 21.36L40.2999 21.29V14.93Z",
    fill: "#BC8169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.12 18.15H10.88C9.28942 18.15 8 19.4394 8 21.03V48.27C8 49.8606 9.28942 51.15 10.88 51.15H53.12C54.7106 51.15 56 49.8606 56 48.27V21.03C56 19.4394 54.7106 18.15 53.12 18.15Z",
    fill: "#DFE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 48.27V21.03C56 20.2662 55.6966 19.5337 55.1565 18.9936C54.6164 18.4535 53.8838 18.15 53.12 18.15H32.24C29.81 24.88 27.63 31.58 27.63 32.34L25.38 36.69L48.15 49.82C49.6711 50.6943 51.3955 51.153 53.15 51.15V51.15C53.9086 51.1421 54.6335 50.8352 55.1671 50.296C55.7007 49.7567 56 49.0287 56 48.27V48.27Z",
    fill: "#CCD8E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1301 34.65H30.2401C29.5884 34.65 29.0601 35.1783 29.0601 35.83V41.72C29.0601 42.3717 29.5884 42.9 30.2401 42.9H35.1301C35.7818 42.9 36.3101 42.3717 36.3101 41.72V35.83C36.3101 35.1783 35.7818 34.65 35.1301 34.65Z",
    fill: "#DFE8F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.12 18.15H10.88C10.1162 18.15 9.38364 18.4535 8.84353 18.9936C8.30343 19.5337 8 20.2662 8 21.03V25.15C7.99975 25.6024 8.11889 26.0468 8.3454 26.4383C8.57191 26.8299 8.89775 27.1547 9.29 27.38L25.38 36.67C27.3921 37.834 29.6755 38.4469 32 38.4469C34.3245 38.4469 36.6079 37.834 38.62 36.67L54.71 27.38C55.1023 27.1547 55.4281 26.8299 55.6546 26.4383C55.8811 26.0468 56.0003 25.6024 56 25.15V21.03C56 20.2662 55.6966 19.5337 55.1565 18.9936C54.6164 18.4535 53.8838 18.15 53.12 18.15V18.15Z",
    fill: "#EBA183"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.45 33.71H29.56C28.9083 33.71 28.38 34.2383 28.38 34.89V40.78C28.38 41.4317 28.9083 41.96 29.56 41.96H34.45C35.1017 41.96 35.63 41.4317 35.63 40.78V34.89C35.63 34.2383 35.1017 33.71 34.45 33.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSingle);
export default __webpack_public_path__ + "static/media/default_single.b297e10618b76904795fbe65e8acdac6.svg";
export { ForwardRef as ReactComponent };